module.exports = __webpack_public_path__ + "static/media/survey.df052d67.jpg";